export default __webpack_public_path__ + "static/media/Boton_2.71018490.webp";